__turbopack_context__.v({
  "carousel": "CountryCityHero-module__REnRRW__carousel",
  "carouselSlide": "CountryCityHero-module__REnRRW__carouselSlide",
  "carouselSlideActive": "CountryCityHero-module__REnRRW__carouselSlideActive",
  "heroImage": "CountryCityHero-module__REnRRW__heroImage",
  "heroMediaWrap": "CountryCityHero-module__REnRRW__heroMediaWrap",
  "heroSection": "CountryCityHero-module__REnRRW__heroSection",
  "heroVideo": "CountryCityHero-module__REnRRW__heroVideo",
  "statItem": "CountryCityHero-module__REnRRW__statItem",
  "statsBar": "CountryCityHero-module__REnRRW__statsBar",
});
